module.exports = __webpack_public_path__ + "img/meishi.66cb6688.png";